// extracted by mini-css-extract-plugin
export var container = "_42-0";
export var disabled = "_42-4";
export var fullWidth = "_42-3";
export var lined = "_42-1";
export var selected = "_42-5";
export var tab = "_42-2";